export const buildShowTrackerFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({ value: o, label: o })),
      },
    ],
  },
  {
    id: 'status',
    label: 'Status',
    filters: [
      {
        id: 'event_status',
        label: 'Status',
        type: 'checkbox',
        options: (filterOptions.status_options || []).map(o => ({ value: o.value, label: o.label })),
      },
    ],
  },
];
